<template>
  <nav class="header-menu">
    <ul role="menu">
      <li
        v-for="(item, i) in menu"
        :key="i"
        role="none"
      >
        <div
          v-if="item.signup"
          class="header-menu__item header-menu__item_highlighted"
        >
          <router-link
            :to="item.to"
            class="header-menu__item button-brand"
            role="menuitem"
          >
            {{ item.name }}
          </router-link>
        </div>
        <router-link
          v-else-if="item.to"
          :to="item.to"
          class="header-menu__item"
          :class="{
            'header-menu__item_highlighted': item.highlighted,
            'header-menu__item_accent': item.accent,
          }"
          role="menuitem"
        >
          <img
            v-if="item.image"
            :src="item.image"
            alt="icon"
            width="30"
            height="30"
            aria-hidden="true"
          >
          <vue-letter-avatar
            v-if="item.defaultImage"
            :name="user.username"
            size="30"
            :rounded=true
          />
          {{ item.name }}
        </router-link>
        <a
          v-else-if="item.href"
          :href="item.href"
          class="header-menu__item"
          role="menuitem"
          target="_blank"
          rel="noopener"
        >
          {{ item.name }}
        </a>
        <HeaderNavigationDropdownItem
          v-else-if="item.menu"
          :item="item"
        />
      </li>
    </ul>
  </nav>
</template>

<script>
import {
  mapGetters,
} from 'vuex';
import HeaderNavigationDropdownItem from '@/components/HeaderNavigationDropdownItem.vue';

export default {
  name: 'HeaderMenu',
  components: {
    HeaderNavigationDropdownItem,
  },
  computed: {
    ...mapGetters({
      menu: 'menu/menu',
      user: 'user/user',
    }),
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/mixins";

.header-menu {
  height: 100%;

  white-space: nowrap;

  @include media-sm-only() {
    display: none;
  }

  > ul {
    display: flex;
    height: inherit;

    > li {
      display: flex;
      align-items: center;

      &:not(:last-child) {
        margin-right: 2rem;
      }
    }
  }

  &__item {
    font-family: inherit;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;

    background-color: transparent;

    &:focus-visible {
      outline: 1px solid var(--gray-1);
    }

    &_accent {
      color: #570c59;
    }

    &_highlighted {
      display: flex;
      align-items: center;
      padding-left: 2rem;

      border-left: 1px solid var(--muted);

      img, svg {
        margin-right: 1rem;

        border-radius: 50%;
        overflow: hidden;

        &:not([src^="https"]) {
          box-shadow: 0 0 0 1px var(--gray-1);
        }
      }
    }
  }

  .button-brand {
    padding: 4px 13px 8px;

    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;
    background: var(--orange);
  }
}
</style>
